import { createFileRoute } from "@tanstack/react-router";
import { ContactTemplate } from "~/features/contact/ContactTemplate";

export const Route = createFileRoute("/_authenticated/contact/")({
  component: ContactTemplate,
});
